export default __webpack_public_path__ + "static/media/getting-started-3.2b48d0ba.png";